import React from 'react';

type Props = {
  fill?: string;
};

const WalletPaymentIcon = ({ fill = 'var(--PRIMARY)' }: Props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.2162 18.3333C20.2162 18.0681 20.3187 17.8138 20.5012 17.6262C20.6837 17.4387 20.9311 17.3333 21.1892 17.3333H23.7838C24.0418 17.3333 24.2893 17.4387 24.4718 17.6262C24.6542 17.8138 24.7568 18.0681 24.7568 18.3333C24.7568 18.5986 24.6542 18.8529 24.4718 19.0404C24.2893 19.228 24.0418 19.3333 23.7838 19.3333H21.1892C20.9311 19.3333 20.6837 19.228 20.5012 19.0404C20.3187 18.8529 20.2162 18.5986 20.2162 18.3333ZM4 6.66667H4.01816C4.09794 5.93332 4.43789 5.25591 4.97303 4.76396C5.50817 4.27201 6.20095 4.00002 6.91892 4H21.8378C22.2212 4 22.6007 4.0776 22.9549 4.22836C23.309 4.37913 23.6308 4.6001 23.9018 4.87868C24.1729 5.15726 24.3879 5.48797 24.5346 5.85195C24.6813 6.21593 24.7568 6.60603 24.7568 7V8.116C25.6802 8.34135 26.5027 8.88025 27.0913 9.64556C27.6798 10.4109 28 11.3578 28 12.3333V23.6667C28 24.8159 27.5558 25.9181 26.7651 26.7308C25.9744 27.5435 24.902 28 23.7838 28H8.21622C7.09801 28 6.02559 27.5435 5.2349 26.7308C4.44421 25.9181 4 24.8159 4 23.6667V6.66667ZM23.7838 10H14.8649H5.94595V23.6667C5.94595 24.9547 6.96303 26 8.21622 26H23.7838C24.3859 26 24.9633 25.7542 25.3891 25.3166C25.8149 24.879 26.0541 24.2855 26.0541 23.6667V12.3333C26.0541 11.7145 25.8149 11.121 25.3891 10.6834C24.9633 10.2458 24.3859 10 23.7838 10ZM22.8108 8V7C22.8108 6.73478 22.7083 6.48043 22.5258 6.29289C22.3434 6.10536 22.0959 6 21.8378 6H6.91892C6.66087 6 6.41339 6.10536 6.23092 6.29289C6.04845 6.48043 5.94595 6.73478 5.94595 7C5.94595 7.26522 6.04845 7.51957 6.23092 7.70711C6.41339 7.89464 6.66087 8 6.91892 8H14.8649H22.8108Z"
      fill={fill}
    />
  </svg>
);

export default WalletPaymentIcon;
